import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";
import {
  buildPageHead,
  breadcrumbSchema,
  webPageSchema,
  personSchema,
} from "@/lib/seo";

export const Route = createFileRoute("/about")({
  head: () =>
    buildPageHead({
      title: "Marjohn Robillo | Revenue Operations Architect | About",
      description:
        "Marjohn Robillo is a Revenue Operations Architect and MPA graduate, Licensed Professional Teacher, MUN-UNESCO Diplomat, and certified GoHighLevel & HubSpot Specialist who builds documented, transferable revenue systems.",
      path: "/about",
      keywords:
        "Marjohn Robillo, about Marjohn Robillo, revenue operations architect, GoHighLevel expert, HubSpot specialist, n8n workflow developer, Philippines automation developer, technical virtual assistant",
      schema: [
        personSchema(),
        webPageSchema({
          name: "About Marjohn Robillo — Revenue Operations Architect",
          description:
            "Credentials, background, and philosophy of Marjohn Robillo, Revenue Operations Architect specializing in CRM automation, n8n workflows, and AI-driven revenue systems.",
          path: "/about",
        }),
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "About", path: "/about" },
        ]),
      ],
    }),
  component: About,
});
